import moment from 'moment';
import momentTZ from 'moment-timezone';

const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;

const DEFAULT_TIME_ZONE = 'Europe/London';
const TIME_ZONE = DEFAULT_TIME_ZONE;

export default moment;

export const MONDAY = 1;
export const TUESDAY = 2;
export const WEDNESDAY = 3;
export const THURSDAY = 4;
export const FRIDAY = 5;
export const SATURDAY = 6;
export const SUNDAY = 0;

export const WEEK = [MONDAY, TUESDAY, WEDNESDAY, THURSDAY, FRIDAY, SATURDAY, SUNDAY];

class GlobalTZ {
  timezone = DEFAULT_TIME_ZONE;

  setTimezone(tz = DEFAULT_TIME_ZONE) {
    this.timezone = tz;
    moment.tz.setDefault(this.timezone);
  }

  getMoment() {
    return (...args) => moment(...args).tz(this.timezone);
    //const date = moment(...args);
    //return getDatetimeWithTimezone(date, this.timezone);
    //return moment(...args);//.tz(this.timezone, true);
    //};
  }
}

export const globalTZ = new GlobalTZ();

const getMomentConstructor = globalTZ.getMoment.bind(globalTZ);

export { getMomentConstructor };

export function isMoment(date) {
  return moment.isMoment(date);
}

export function getSecondsPerHour() {
  return SECONDS_IN_HOUR;
}

export function getMomentDate(date) {
  return moment(date);
}

export function getDateAsISOString(date) {
  return getMomentDate(date).format();
}

export function getDateAsForceISOString(date) {
  return getMomentDate(date).toISOString();
}

export function setLocale(locale) {
  moment.locale(locale);
}

export function getDaysInMonth(date) {
  return getMomentDate(date).daysInMonth();
}

export function getDatesDiffInDays(startDate, endDate) {
  return getMomentDate(startDate).diff(getMomentDate(endDate), 'days');
}

export function getDatesDiffInYears(startDate, endDate) {
  return getMomentDate(startDate).diff(getMomentDate(endDate), 'years');
}

export function getDateStartTime(date) {
  return getMomentDate(date).startOf('day');
}

export function getDateEndTime(date) {
  return getMomentDate(date).endOf('day');
}

export function getValidDateObject(date) {
  return getMomentDate(date).toDate();
}

export function isDateAfter(firstDate, secondDate) {
  return getMomentDate(firstDate).isAfter(getMomentDate(secondDate));
}

export function isDateBefore(firstDate, secondDate) {
  return getMomentDate(firstDate).isBefore(getMomentDate(secondDate));
}

export function isDateSame(firstDate, secondDate) {
  return getMomentDate(firstDate).isSame(getMomentDate(secondDate));
}

export function isSameYear(firstDate, secondDate) {
  return getMomentDate(firstDate).isSame(getMomentDate(secondDate), 'year');
}

export function isSameMonth(firstDate, secondDate) {
  return getMomentDate(firstDate).isSame(getMomentDate(secondDate), 'month');
}

export function isSameDay(firstDate, secondDate) {
  return getMomentDate(firstDate).isSame(getMomentDate(secondDate), 'day');
}

export function subtractDaysFromDate(date, daysCount) {
  return getMomentDate(date).subtract(daysCount, 'days');
}

export function subtractMonthsFromDate(date, monthsCount) {
  return getMomentDate(date).subtract(monthsCount, 'months');
}

export function addDaysToDate(date, daysCount) {
  return getMomentDate(date).add(daysCount, 'days');
}

export function addMonthsToDate(date, monthsCount) {
  return getMomentDate(date).add(monthsCount, 'month');
}

export function getMonthStartDate(date) {
  return getMomentDate(date).startOf('month');
}

export function getCurrentYear() {
  return getMomentDate().year();
}

export function getCurrentMonth() {
  return getMomentDate().month();
}

export function getMonthsArray() {
  return moment.months();
}

export function getEndOfMonthDate(date) {
  return getMomentDate(date).endOf('month');
}

export function getDatetimeWithTimezone(date, timezone = TIME_ZONE) {
  return momentTZ.tz(moment(date), timezone);
}

export function getDateAsForceISOStringTZ(date) {
  return getDatetimeWithTimezone(date).toISOString();
}

export function getDateTimeFromSeconds(seconds) {
  return getDateStartTime().add(seconds, 'seconds');
}

export function formatDateToCustomDateFormat(date, format) {
  return getMomentDate(date).format(format);
}

export function getDaysDiff(dateA, dateB) {
  return getMomentDate(dateA).diff(getMomentDate(dateB), 'days');
}

export function getDiffFromNow(date) {
  return moment(date).fromNow(true);
}

export function getWeekday(date) {
  return getMomentDate(date).day();
}

export function isWeekend(date) {
  const weekday = getWeekday(date);
  return weekday === SATURDAY || weekday === SUNDAY;
}

export function getDateInMilliseconds(date) {
  return moment(date).valueOf();
}

export function getDateUTCAsISOString(date) {
  return getDateAsISOString(getMomentDate(date).utc());
}

export function getDateStartTimeAsISOString(date) {
  return getDateAsISOString(getDateStartTime(date));
}

export function getDateEndTimeAsISOString(date) {
  return getDateAsISOString(getDateEndTime(date));
}
